export const ANALYTICS_CLASS = {
    LINK: "trackableLink"
};
